import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {numericValidator} from '../../../validators/numeric-validator';
import {passwordMatchValidator} from '../../../validators/password-match';
import {UserService} from '../../../services/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegisterComponent implements OnInit {
  public personalForm: FormGroup;
  public locationForm: FormGroup;
  public preferencesForm: FormGroup;
  public accountForm: FormGroup;

  public errorMsg: string = '';
  public loading: boolean = false;

  public personalOpenState: boolean = true;
  public locationOpenState: boolean = false;
  public preferencesOpenState: boolean = false;
  public registerOpenState: boolean = false;
  public accountOpenState: boolean = false;

  public employmentStatus: 'active' | 'retired';

  constructor(
    public fb: FormBuilder,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.personalForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      employeeNumber: [
        '',
        [Validators.required, Validators.minLength(8), numericValidator()],
      ],
    });

    this.locationForm = this.fb.group({
      branchNumber: [{value: '', disabled: false}],
    });

    this.preferencesForm = this.fb.group({
      receiveMarketingEmails: [false],
    });

    this.accountForm = this.fb.group(
      {
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
        passwordConfirm: ['', [Validators.required]],
      },
      {validators: passwordMatchValidator}
    );
  }
  updateEmploymentStatus(status: 'active' | 'retired') {
    this.employmentStatus = status;
    const branchControl = this.locationForm.get('branchNumber');

    if (status === 'active') {
      branchControl?.enable();
    } else {
      branchControl?.disable();
      branchControl?.reset();
      this.setPanelState('preferences');
    }
  }

  setPanelState(panel: string) {
    this.personalOpenState = panel === 'personal';
    this.locationOpenState = panel === 'location';
    this.preferencesOpenState = panel === 'preferences';
    this.registerOpenState = panel === 'register';
    this.accountOpenState = panel === 'account';
  }

  async register() {
    try {
      if (
        this.personalForm.invalid ||
        this.locationForm.invalid ||
        this.preferencesForm.invalid ||
        this.accountForm.invalid
      ) {
        return;
      }

      this.loading = true;

      const features =
        this.preferencesForm.getRawValue().receiveMarketingEmails === true
          ? {receive_marketing_emails: true}
          : {};

      const user: any = {
        email: this.accountForm.getRawValue().email,
        employee_number: this.personalForm.getRawValue().employeeNumber,
        features: features,
        first_name: this.personalForm.getRawValue().firstName,
        last_name: this.personalForm.getRawValue().lastName,
        password: this.accountForm.getRawValue().password,
        passwordConfirm: this.accountForm.getRawValue().passwordConfirm,
      };

      // Handle employment status
      if (this.employmentStatus === 'retired') {
        user.retired_partner = true;
      }

      if (this.employmentStatus === 'active') {
        user.branch_number = this.locationForm.getRawValue().branchNumber;
      }

      const response = await this.userService.registerUser({User: user});

      if (response.body.status === true) {
        this.router.navigate(['/Login'], {
          state: {message: 'Account created successfully! Please log in.'},
        });
      }
    } catch (error) {
      this.errorMsg =
        'An error occurred during registration. Please check whether your email address is already registered or if your employee number is valid.';
      this.loading = false;
    }
  }
}
